export class MacroModulo {
  public id?: string;
  public nome?: string;
  public descrizione?: string;
  public figure?: string;
  public filename?: string;
  public image?: string;
}
